import SvgIcon, { SvgIconProps } from "@mui/material/SvgIcon";

type SFFingerprintProps = Omit<SvgIconProps, "color"> & {
  color?: string;
  width?: number;
  height?: number;
  strokeWidth?: number;
};

export default function SFFingerprintIcon({
  color = "white",
  width = 24,
  height = 24,
  strokeWidth = 2,
  ...props
}: SFFingerprintProps) {
  return (
    <SvgIcon {...props}>
      <svg
        width={width}
        height={height}
        viewBox={`0 0 ${width} ${height}`}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_113_4042)">
          <path
            d="M12.2045 12.0552C13.0094 15.0673 11.9967 18.1444 9.82849 20.092"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
          />
          <path
            d="M4.42092 14.0676C3.03818 8.71193 7.28379 4.0119 12.2045 4.0119C16.7293 4.0119 20.4815 7.36165 20.5205 14.0611"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
          />
          <path
            d="M6.41382 17.6381C9.36107 15.9762 8.17957 12.8666 8.17957 12.0552C8.17957 9.89341 9.93235 8.03677 12.2045 8.03677C16.8396 8.03677 16.6578 14.1066 16.3397 16.0801C16.1125 17.5017 15.6256 18.865 14.9245 20.0984"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M0.64917 5.75818V4.43386C0.64917 1.75277 1.75277 0.64917 4.43386 0.64917H5.75818"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
          />
          <path
            d="M5.75818 23.3508H4.43386C1.75277 23.3508 0.64917 22.2472 0.64917 19.5661V18.2418"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
          />
          <path
            d="M23.3508 18.2418V19.5661C23.3508 22.2472 22.2472 23.3508 19.5661 23.3508H18.2418"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
          />
          <path
            d="M18.2418 0.64917H19.5661C22.2472 0.64917 23.3508 1.75277 23.3508 4.43386V5.75818"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_113_4042">
            <rect width="24" height="24" fill={color} />
          </clipPath>
        </defs>
      </svg>
    </SvgIcon>
  );
}
